/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Plano, SimulateTypes } from 'store/modules/simulate_all_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import { ApplicationState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from './style';

interface SelectPlansProps {
  plan: string;
  prices: Plano;
  packageName: string;
}

const RenewalPlan: React.FC<SelectPlansProps> = ({ plan, prices, packageName }) => {
  const dispatch = useDispatch();
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const handleClick = (planType: string) => {
    let planId;

    switch (planType.toLocaleLowerCase()) {
      case 'semestral':
        planId = 4;
        break;
      case 'anual':
        planId = 5;
        break;
      default:
        planId = 6;
    }

    dispatch({
      type: SimulateTypes.PLAN_ID_NAME,
      plan: planId,
      name: planType,
      pacote: packageName,
    });

    window.location.href = '/finalizar_assinatura';
  };

  const renderPlanDetails = (planType: string) => {
    const dataFinal = panel?.renewal_campaign?.subscription_end_date;
    return (
      <>
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="font-weight-bold title_period">
              Plano{' '}
              {packageName.toLowerCase().charAt(0).toUpperCase() +
                packageName.toLowerCase().slice(1)}
            </div>
          </div>
        </div>
        <div className="card px-5 py-4 border-green text-center">
          <span className="font-weight-bold text-center font_17">Nova vigência até</span>
          <span className="font-weight-bold text-center font_17">
            {sugerirVigencia(dataFinal, planType)}
          </span>
          <hr className="hr_renewal_plan" />
          <p className="font_16">Valores abaixo já com 10% de desconto aplicado</p>
          <p className="font-weight-bold price mb-0">
            {prices.original.valor_base.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </p>
          <span>no boleto à vista</span>
          <span>ou</span>
          <p className="font-weight-bold price mb-0 ">
            {prices.original.valor_final.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </p>
          <span>(10% Off)</span>
          <span className="parcel mt-2">{`até ${
            planType === 'semestral' ? 3 : planType === 'anual' ? 5 : 8
          }x sem juros no cartão`}</span>
          <button
            type="button"
            className="btn btn-success mt-3 font-weight-bold"
            onClick={() => handleClick(planType)}
          >
            Quero Renovar
          </button>
        </div>
      </>
    );
  };

  function sugerirVigencia(dataFinal: string, periodo: string): string {
    const [dia, mes, ano] = dataFinal.split('/').map(Number);
    const data = new Date(ano, mes - 1, dia);

    const novaData = new Date(data);

    switch (periodo) {
      case 'semestral':
        novaData.setMonth(data.getMonth() + 6);
        break;
      case 'anual':
        novaData.setFullYear(data.getFullYear() + 1);
        break;
      case 'bienal':
        novaData.setFullYear(data.getFullYear() + 2);
        break;
      default:
        throw new Error('Período inválido');
    }

    const formatarData = (data: Date): string => {
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const ano = data.getFullYear();
      return `${dia}/${mes}/${ano}`;
    };

    return formatarData(novaData);
  }

  return <Container className="col-md-4">{renderPlanDetails(plan.toLowerCase())}</Container>;
};

export default RenewalPlan;
